export const columnasRendiciones = [
    {
        key: "descripcionTipoComprobante",
        label: "Comprobante",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "cae",
        label: "CAE/CAI",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "numero",
        label: "Número de factura",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "cuit",
        label: "CUIT",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "razonSocial",
        label: "Razón Social",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "descripcionConceptoGasto",
        label: "Concepto",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "fecha",
        label: "Fecha",
        sorted: true,
        fixed: false,
        type: "date",
        hidden: false,
    },
    {
        key: "importeFormateado",
        label: "Importe",
        sorted: true,
        fixed: false,
        type: "number",
        hidden: false,
        sortKey: "currency"
    },
    {
        key: "descripción",
        label: "Observaciones",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "acciones",
        label: "",
        sorted: false,
        fixed: false,
        type: "component",
        hidden: false,
    },
];